import { FunctionComponent } from "react";
import { NextLink } from "../../Links";
import { LinkIcon } from "@heroicons/react/24/outline";
import { cva, VariantProps } from "class-variance-authority";
import { Nil } from "cy-util";
import { cn } from "../../../utils/cn";

const statStyles = cva(
  ["relative rounded-2xl bg-white basis-0  py-4 px-5", "flex-grow sm:w-fit"],
  {
    variants: {
      outline: {
        true: "border bg-gray-50",
        false: "",
      },
    },
  },
);

export interface StatisticProps extends VariantProps<typeof statStyles> {
  className?: string;
  value: string | number | Nil;
  label: string;
  href?: string;
}

/**
 *
 */
export const Stat: FunctionComponent<StatisticProps> = ({
  className,
  label,
  href,
  value,
  outline,
}) => {
  return (
    <NextLink href={href} className={statStyles({ className, outline })}>
      <div className={cn("flex h-11 items-center")}>
        <div>
          {!!href && <LinkIcon className="absolute right-3 top-3 h-4 w-4" />}
          <div className={cn("whitespace-nowrap text-2xl font-medium")}>
            {value != null ? value : ""}
          </div>
          <div className="whitespace-nowrap text-sm opacity-70">{label}</div>
        </div>
      </div>
    </NextLink>
  );
};

export default Stat;
